var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/care-office-surrounding.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-73666343!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/care-office-surrounding.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/CareOfficeSurrounding.vue
// module id = 298
// module chunks = 1